import { useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { getUserFromStorage } from '../services/user';
import { getAuthTokenFromStorage, getUserIdFromStorage } from '../utils';

async function isUserAdmin(redirect) {
  if (!getAuthTokenFromStorage() || !getUserIdFromStorage()) redirect();
  else {
    const { is_admin: isAdmin } = await getUserFromStorage();
    if (!isAdmin) redirect();
  }
}

const RequireAdminAuth = (props) => {
  const {
    children,
    history,
  } = props;

  useEffect(() => {
    isUserAdmin(() => history.push('/'));
  }, []);

  return children;
};

export default withRouter(RequireAdminAuth);
